import './banar.css'
import image from '../../assets/Images/Img1.png'
import { socialData } from '../../DataFiles/socialData'
import { Link } from "react-scroll";

const Banar = () => {
 
   return (
      <>
         <div className="banarSection overflow" id='home'>
            <div className="container banarsection2" >
               <div className="row">
                  <div className="banarRightSide col-lg-6 col-md-12 aos rightleftSide" data-aos="fade-right">
                     <div className='introBanar'>
                        <p className="intro1">Hi There, I'm</p>
                        <h2 className="intro">Nilesh Lad</h2>
                        <h4 className="subheading">Frontend developer</h4>
                        <div className="btnGroup">
                           <Link to='Contact'  smooth={true} duration={100} >
                              <button className='btn'>Contact me</button></Link>
                        </div>
                        <div className="socialMedia socialMedia3">
                           {socialData.map((s) => (
                              <span className='icon' key={s.link}>
                                 <a href={s.link}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                 >
                                    <i className={s.icon}></i>
                                 </a>
                              </span>
                           ))}
                        </div>
                     </div>
                  </div>
                  <div className="banarLeftSide col-lg-6 col-md-12 aos rightleftSide" data-aos="fade-left">
                     <div className="profileImage image">
                        <img src={image} alt="" />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Banar